<template>
  <component
    :is="component[props.type]"
    :id="id"
    :container-start-date="containerStartDate"
    :container-end-date="containerEndDate"
    :content-can-be-hidden="props.contentCanBeHidden"
    :packed-element="props.packedElement"
  />
</template>

<script setup lang="ts">
import { type Component } from 'vue'
import { type CalendarItemType } from '@/constants/persoplan'

import { type Props as PropsAppointmentsContainerPure } from '@/components/persoplan/PmAppointmentsContainer/PmAppointmentsContainerPure.vue'
import PmJob from '@/components/persoplan/PmJob/PmJob.vue'
import PmProject from '@/components/persoplan/PmProject/PmProject.vue'
import type { PackingItem } from '@/functional/packing'

const component = {
  project: PmProject,
  job: PmJob,
} as const satisfies Partial<Record<CalendarItemType, Component>>

export type Props = Pick<
  PropsAppointmentsContainerPure,
  'containerStartDate' | 'containerEndDate'
> & {
  id: number
  type: string
  contentCanBeHidden: boolean | undefined
  packedElement?: PackingItem
}

const props = withDefaults(defineProps<Props>(), {})
</script>
